var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Not Found "),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v(" Home ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }